import * as z from "zod";
import { userFacingError } from "../authorization";
import { assertIdpSyncNotActive } from "../rbac/validation";
import { assertUserDeactivatable } from "../userDeactivation";
import { monitoringAnalytics } from "./monitoringAnalytics";
import { mutator } from "./mutator";

export const deactivateUserSchema = z.object({
  analytics: monitoringAnalytics.optional(),
  userId: z.string(),
});

export const deactivateUser = mutator({
  stripKeys: { analytics: Object.keys(monitoringAnalytics.shape) },
  schema: deactivateUserSchema,
  resolve: {
    target: { kind: "user", from: "userId" },
  },
  permissions: [
    { permission: "tenant:users_manage", scopeId: ({ ctx }) => ctx.tenantId },
  ],
  fn: async ({ tx, ctx, args: { target } }) => {
    await assertIdpSyncNotActive(tx, ctx.tenantId, "userActivation");
    if (target.id === ctx.userId)
      throw userFacingError("Cannot deactivate yourself");

    await assertUserDeactivatable(tx, ctx.tenantId, target.id);

    await tx.mutate.user.update({ id: target.id, deactivated: true });
  },
});
